/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, String_$type, Number_$type, fromEnum, markType } from "igniteui-react-core";
import { Dictionary$2 } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { HashSet$1 } from "igniteui-react-core";
import { Replaced } from "./Replaced";
import { ObservableCollection$1 } from "igniteui-react-core";
/**
 * @hidden
 */
var MaskParsingService = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(MaskParsingService, _super);
    function MaskParsingService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaskParsingService.prototype.h = function (a, b) {
        var e_1, _a, e_2, _b;
        var c = "";
        var d = "";
        var e = b.a;
        var f = this.d(e);
        var g = new List$1(Number_$type, 1, f.keys);
        var h = this.e(e, g);
        var i = new List$1(String_$type, 1, f.values);
        if (a != null) {
            d = a.toString();
        }
        for (var j = 0; j < e.length; j++) {
            c += b.b;
        }
        try {
            for (var _c = tslib_1.__values(fromEnum(f)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var k = _d.value;
                c = this.j(c, k.key, k.value);
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return))
                    _a.call(_c);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        if (d == "") {
            return c;
        }
        var l = this.f(d, i);
        for (var m = 0; m < l.count; m++) {
            var n = l._inner[m];
            var o = this.c(n, h._inner[m], e);
            if (!o && n != b.b) {
                l._inner[m] = b.b;
            }
        }
        if (l.count > h.count) {
            l.v(h.count + 1, l.count);
        }
        var p = 0;
        try {
            for (var _e = tslib_1.__values(fromEnum(l)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var q = _f.value;
                var r = q;
                c = this.j(c, h._inner[p++], r);
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return))
                    _b.call(_e);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        return c;
    };
    MaskParsingService.prototype.i = function (a, b) {
        var e_3, _a;
        var c = "";
        var d = b.a;
        var e = this.d(d);
        var f = new HashSet$1(String_$type, 0);
        try {
            for (var _b = tslib_1.__values(fromEnum(e.values)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var g = _c.value;
                f.add_1(g);
            }
        }
        catch (e_3_1) {
            e_3 = { error: e_3_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_3)
                    throw e_3.error;
            }
        }
        for (var h = 0; h < a.length; h++) {
            var i = a.charAt(h).toString();
            if (!f.contains(i)) {
                if (i != b.b) {
                    c += i;
                }
            }
        }
        return c;
    };
    MaskParsingService.prototype.a = function (a, b, c, d, e) {
        var f = this.d(c.a);
        var g = new ObservableCollection$1(String_$type, 0);
        for (var h = 0; h < b.length; h++) {
            g.add(b.charAt(h).toString());
        }
        var i = d;
        e = Math.min(e, a.length);
        for (var j = d; j < e || (g.count > 0 && j < a.length); j++) {
            if (f.containsKey(j)) {
                if (g._inner[0] == a.charAt(j).toString()) {
                    i = j + 1;
                    g.removeAt(0);
                }
                continue;
            }
            if (g._inner[0] != null && !this.c(g._inner[0].toString(), j, c.a) && g._inner[0].toString() != c.b) {
                break;
            }
            var k = c.b;
            if (g.count > 0) {
                i = j + 1;
                k = g._inner[0];
                g.removeAt(0);
            }
            a = this.j(a, j, k);
        }
        var l = new Replaced();
        l.b = a;
        l.a = i;
        return l;
    };
    MaskParsingService.prototype.j = function (a, b, c) {
        if (a != null) {
            return a.substr(0, b) + c + a.substr(b + 1);
        }
        return null;
    };
    MaskParsingService.prototype.b = function (a, b) {
        return a.test(b);
    };
    MaskParsingService.prototype.c = function (a, b, c) {
        var d;
        var e;
        var f = "[\\d\\u00C0-\\u1FFF\\u2C00-\\uD7FFa-zA-Z]";
        var g = "[\\d\\u00C0-\\u1FFF\\u2C00-\\uD7FFa-zA-Z\\u0020]";
        var h = "[\\u00C0-\\u1FFF\\u2C00-\\uD7FFa-zA-Z]";
        var i = "[\\u00C0-\\u1FFF\\u2C00-\\uD7FFa-zA-Z\\u0020]";
        var j = "[\\d]";
        var k = "[\\d\\u0020]";
        var l = "[\\d-\\+\\s]";
        switch (c.charAt(b)) {
            case 'C':
                e = a != "";
                break;
            case '&':
                d = new RegExp("[\\u0020]");
                e = !this.b(d, a);
                break;
            case 'a':
                d = new RegExp(g);
                e = this.b(d, a);
                break;
            case 'A':
                d = new RegExp(f);
                e = this.b(d, a);
                break;
            case '?':
                d = new RegExp(i);
                e = this.b(d, a);
                break;
            case 'L':
                d = new RegExp(h);
                e = this.b(d, a);
                break;
            case '0':
                d = new RegExp(j);
                e = this.b(d, a);
                break;
            case '9':
                d = new RegExp(k);
                e = this.b(d, a);
                break;
            case '#':
                d = new RegExp(l);
                e = this.b(d, a);
                break;
            default:
                e = false;
                break;
        }
        return e;
    };
    MaskParsingService.prototype.d = function (a) {
        var b = new Dictionary$2(Number_$type, String_$type, 0);
        for (var c = 0; c < a.length; c++) {
            var d = a.charAt(c);
            if (!MaskParsingService.g.contains(d)) {
                b.addItem(c, d.toString());
            }
        }
        return b;
    };
    MaskParsingService.prototype.e = function (a, b) {
        var c = new List$1(Number_$type, 0);
        for (var d = 0; d < a.length; d++) {
            if (!b.contains(d)) {
                c.add(d);
            }
        }
        return c;
    };
    MaskParsingService.prototype.f = function (a, b) {
        var c = new List$1(String_$type, 0);
        for (var d = 0; d < a.length; d++) {
            var e = a.charAt(d).toString();
            if (!b.contains(e)) {
                b.remove(e);
                c.add(e);
            }
        }
        return c;
    };
    MaskParsingService.$t = markType(MaskParsingService, 'MaskParsingService');
    MaskParsingService.g = ((function () {
        var $ret = new List$1(String_$type, 0);
        $ret.add('C');
        $ret.add('&');
        $ret.add('a');
        $ret.add('A');
        $ret.add('?');
        $ret.add('L');
        $ret.add('9');
        $ret.add('0');
        $ret.add('#');
        return $ret;
    })());
    return MaskParsingService;
}(Base));
export { MaskParsingService };
//# sourceMappingURL=MaskParsingService.js.map
